import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-report",
  "use": "icon-report-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-report\"><defs><style type=\"text/css\"></style></defs><path d=\"M546.133333 477.866667 546.133333 0C810.052267 0 1024 213.947733 1024 477.866667L546.133333 477.866667ZM887.466667 614.4 885.742933 614.4C868.2496 843.4688 677.2736 1024 443.733333 1024 198.673067 1024 0 825.326933 0 580.266667 0 335.189333 198.673067 136.533333 443.733333 136.533333 455.253333 136.533333 466.568533 137.386667 477.866667 138.257067L477.866667 204.8 477.866667 206.523733 477.866667 546.133333 887.466667 546.133333 887.466667 614.4ZM477.866667 614.4 409.6 614.4 409.6 546.133333 409.6 206.523733C218.248533 223.7952 68.266667 384.426667 68.266667 580.266667 68.266667 787.626667 236.373333 955.733333 443.733333 955.733333 639.573333 955.733333 800.2048 805.751467 817.476267 614.4L477.866667 614.4Z\" p-id=\"15644\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/report.svg
// module id = 2nwU
// module chunks = 45